import { render, staticRenderFns } from "./basicHeader.vue?vue&type=template&id=6de13dd3"
import script from "./basicHeader.vue?vue&type=script&lang=js"
export * from "./basicHeader.vue?vue&type=script&lang=js"
import style0 from "./basicHeader.vue?vue&type=style&index=0&id=6de13dd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports